export default __webpack_public_path__ + "static/media/TermsOfServicePage.9bc9226f.jpeg";